// extracted by mini-css-extract-plugin
module.exports = {"formattedContent":"_3AtkvlaE","secondary":"_3KcyXQGv","contrastedLink":"_1rXPKHuf"};